<template>
  <div class="gnb-container" :class="[{ 'golf-gnb': isGolfService }]">
    <div
      v-show="focusedView == 'gnb'"
      class="mouseover-obs"
      @mouseover="mouseOff"
    ></div>
    <div
      class="gnb-main"
      :class="[{ 'gnb-focused': isFocusOn }]"
      @click="enterKeyProc"
      @mousemove="mouseMove()"
    >
      <div
        class="menu profile"
        :class="{ focused: isFocusedMenu(0), selected: isSelectedMenu(0) }"
      >
        <img class="menu-profile-icon" src="@/assets/profile-ic.png" />
        <span v-show="isFocusOn" class="menu-text">{{ userName }}</span>
        <div class="select-bar" v-if="isSelectedMenu(0)"></div>
      </div>
      <div
        class="menu home"
        :class="{ focused: isFocusedMenu(1), selected: isSelectedMenu(1) }"
        @mouseover="mouseOver(1)"
      >
        <img
          class="menu-icon"
          src="@/assets/home.png"
          v-if="isSelectedMenu(1)"
        />
        <img class="menu-icon" src="@/assets/home-u.png" v-else />
        <span v-show="isFocusOn" class="menu-text">홈</span>
        <div class="select-bar" v-if="isSelectedMenu(1)"></div>
      </div>
      <div
        class="menu league"
        :class="{ focused: isFocusedMenu(2), selected: isSelectedMenu(2) }"
        @mouseover="mouseOver(2)"
      >
        <img class="menu-icon" src="@/assets/my.png" v-if="isSelectedMenu(2)" />
        <img class="menu-icon" src="@/assets/my-u.png" v-else />
        <span v-show="isFocusOn" class="menu-text">
          {{ isGolfService ? "투어" : "리그" }}
        </span>
        <div class="select-bar" v-if="isSelectedMenu(2)"></div>
      </div>
      <div
        class="menu program"
        :class="{ focused: isFocusedMenu(3), selected: isSelectedMenu(3) }"
        @mouseover="mouseOver(3)"
      >
        <img
          class="menu-icon"
          src="@/assets/channel.png"
          v-if="isSelectedMenu(3)"
        />
        <img class="menu-icon" src="@/assets/channel-u.png" v-else />
        <span v-show="isFocusOn" class="menu-text">프로그램</span>
        <div class="select-bar" v-if="isSelectedMenu(3)"></div>
      </div>
      <div
        class="menu setting"
        :class="{ focused: isFocusedMenu(4), selected: isSelectedMenu(4) }"
        @mouseover="mouseOver(4)"
      >
        <img
          class="menu-icon"
          src="@/assets/setting-f.png"
          v-if="isSelectedMenu(4)"
        />
        <img class="menu-icon" src="@/assets/setting-u.png" v-else />
        <span v-show="isFocusOn" class="menu-text">설정</span>
        <div class="select-bar" v-if="isSelectedMenu(4)"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { isGolf } from "@/utils/common";
import { HYUNDAI_WIDTH } from "@/helpers/const";

export default {
  data() {
    return {
      isActiveVue: true,
      isFocusOn: false,
      focusedIndex: this.gnbFocus,
      selectedIndex: this.gnbFocus,
      maxIndex: 4,
      focusTimer: null,
      isGolfService: isGolf,
    };
  },
  props: {
    gnbFocus: Number,
  },
  computed: {
    keyInput() {
      return this.$store.getters.keyInput;
    },
    focusedView() {
      return this.$store.getters.focusedView;
    },
    userName() {
      return this.$store.getters.userInfo.name;
    },
    isHDResolution() {
      return window.innerWidth === HYUNDAI_WIDTH;
    },
  },
  watch: {
    focusedView(val) {
      if (val == "gnb") {
        this.isFocusOn = true;

        if (this.isHDResolution) {
          this.mouseMove();
        }
      } else {
        this.isFocusOn = false;
        this.focusedIndex = this.selectedIndex;

        if (this.isHDResolution) {
          clearTimeout(this.focusTimer);
          this.focusTimer = null;
        }
      }
    },
    keyInput(val) {
      if (this.isActiveVue && val.focusView == "gnb") {
        switch (val.key) {
          case "ArrowUp":
            this.upKeyProc(val);
            break;
          case "ArrowDown":
            this.downKeyProc(val);
            break;
          case "ArrowRight":
            this.rightKeyProc(val);
            break;
          case "Enter":
            this.enterKeyProc(val);
            break;
          case "Backspace":
            this.backKeyProc(val);
            break;
        }
      }
    },
    focusedIndex(val, oldVal) {
      if (this.isHDResolution) {
        this.mouseMove();
      }
    },
  },
  methods: {
    upKeyProc(keyInput) {
      if (this.focusedIndex > 1) {
        this.focusedIndex -= 1;
      }
    },
    downKeyProc(keyInput) {
      if (this.focusedIndex < this.maxIndex) {
        this.focusedIndex += 1;
      }
    },
    rightKeyProc(keyInput) {
      this.focusedIndex = this.selectedIndex;
      this.$store.commit("SET_FOCUSED_VIEW", "default");
    },
    enterKeyProc(keyInput) {
      const GNB_ROUTE_MAP = {
        0: "my-page", // 사용하지 않고 있음
        1: "home",
        2: "league",
        3: "program",
        4: "setting",
      };

      if (this.focusedIndex === this.selectedIndex) {
        // 설정 메뉴만 클릭 시 마다 페이지 이동
        if (this.focusedIndex == 4) {
          this.movePage(GNB_ROUTE_MAP[this.focusedIndex]);
        }
      } else {
        this.selectedIndex = this.focusedIndex;
        this.movePage(GNB_ROUTE_MAP[this.focusedIndex]);
      }
    },
    backKeyProc(keyInput) {
      this.$router.push({
        name: "exit",
        params: {
          t: new Date().getTime(),
        },
      });
    },
    isFocusedMenu(index) {
      return this.isFocusOn && index == this.focusedIndex;
    },
    isSelectedMenu(index) {
      return index == this.selectedIndex;
    },
    mouseOver(index) {
      this.focusedIndex = index;
      this.$store.commit("SET_FOCUSED_VIEW", "gnb");
    },
    mouseOff(index) {
      this.$store.commit("SET_FOCUSED_VIEW", "default");
    },
    mouseMove() {
      if (this.isHDResolution) {
        clearTimeout(this.focusTimer);
        this.focusTimer = setTimeout(() => {
          this.isFocusOn = false;
          this.rightKeyProc();
        }, 4000);
      }
    },
    movePage(routerName) {
      this.$router.replace({
        name: routerName,
        params: {
          t: new Date().getTime(),
        },
      });
    },
  },
  activated() {
    this.isActiveVue = true;
  },
  deactivated() {
    this.isActiveVue = false;

    if (this.focusTimer) {
      clearTimeout(this.focusTimer);
      this.focusTimer = null;
    }
  },
};
</script>

<style lang="less" scoped>
.gnb-container {
  .mouseover-obs {
    position: absolute;
    top: 0;
    left: 0;
    height: 1080px;
    width: 1920px;
    z-index: 3;
  }

  .gnb-main {
    position: absolute;
    z-index: 10;
    left: 0;
    top: 0;
    width: 136px;
    height: 1080px;
    background-color: rgba(30, 30, 30, 0.95);
    transition: width 0.2s;

    &.gnb-focused {
      width: 354px;
    }

    .menu {
      height: 57px;
      padding-left: 44px;
      padding-top: 23px;
      margin-top: 10px;
      margin-bottom: 10px;

      &.focused {
        background-color: rgba(62, 62, 62, 0.95);
        border-top: solid 2px #eeeeee;
        border-bottom: solid 2px #eeeeee;
        padding-top: 21px;
        height: 55px;
      }

      &.selected {
        .menu-text {
          color: #eeeeee;
        }
      }

      &.profile {
        margin-top: 36px;
        margin-bottom: 63px;

        .menu-text {
          color: #eeeeee;
        }
      }

      .menu-text {
        position: absolute;
        width: 200px;
        margin-left: 20px;
        font-size: 28px;
        line-height: 46px;
        color: #888888;
      }

      .select-bar {
        width: 40px;
        height: 4px;
        margin-top: 2px;
        background-color: #2affcc;
      }
    }
  }

  &.golf-gnb {
    .gnb-main {
      .menu {
        .select-bar {
          background-color: #ff4600;
        }
      }
    }
  }
}

@media all and (min-width: 0px) and (max-width: 1280px) {
  .gnb-container {
    .gnb-main {
      position: absolute;
      z-index: 10;
      left: 0;
      top: 0;
      width: 88px;
      height: 1080px;
      background-color: rgba(30, 30, 30, 0.95);
      transition: width 0.2s;

      &.gnb-focused {
        width: 240px;
      }

      .menu {
        height: 56px;
        padding-left: 28px;
        padding-top: 12px;
        margin-top: 10px;
        margin-bottom: 10px;
        border-top: solid 1px transparent;
        border-bottom: solid 1px transparent;

        &.focused {
          background-color: rgba(62, 62, 62, 0.95);
          border-top: solid 1px #eeeeee;
          border-bottom: solid 1px #eeeeee;
          padding-top: 12px;
          height: 56px;
        }

        &.profile {
          margin-top: 34px;
          margin-bottom: 22px;
        }

        .menu-profile-icon {
          width: 32px;
          height: 32px;
        }

        .menu-icon {
          width: 28px;
          height: 28px;
        }

        .menu-text {
          position: absolute;
          width: 200px;
          margin-left: 16px;
          font-size: 20px;
          font-weight: bold;
          line-height: 28px;
          color: #888888;
        }

        .select-bar {
          width: 28px;
          height: 3px;
        }
      }
    }
  }
}
</style>
